import type { ComponentProps } from 'react'
import { Dropdown } from 'react-native-element-dropdown'
import type { DropdownProps } from 'react-native-element-dropdown/lib/typescript/components/Dropdown/model'
import { withUnistyles } from 'react-native-unistyles'

import type { Theme } from '@/styles/theme'

const BaseDropdown = withUnistyles(Dropdown)

type BaseDropdownProps = ComponentProps<typeof BaseDropdown>

type UniDropdownProps<T> = DropdownProps<T> & {
  getThemeProps?: (theme: Theme) => Partial<DropdownProps<T>>
}

const UniDropdown = <T,>({ getThemeProps, ...rest }: UniDropdownProps<T>) => {
  return (
    <BaseDropdown
      {...(rest as unknown as BaseDropdownProps)}
      uniProps={
        getThemeProps
          ? (((theme: Theme) =>
              getThemeProps(theme)) as BaseDropdownProps['uniProps'])
          : undefined
      }
    />
  )
}

export default UniDropdown
